//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openWordStudy } from '@/utils/openWordStudy'
export default {
  data () { return { data: {} } },
  created () {
    this.$ajax.get(this.$api.mpReviewResult + '?record_id=' + this.$route.query.record_id).then(r => { this.data = r || {} })
  },
  methods: {
    study (w) {
      openWordStudy(this.$router, w.word || w.word_text || w.wordText)
    },
    addWrong () {
      this.$ajax.post(this.$api.mpReviewAddWrong, { record_id: this.$route.query.record_id }).then(r => {
        this.$toast && this.$toast('已加入 ' + (r.added || 0) + ' 词')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/result.vue